<template>
  <base-stack class="statistics">
    <base-stack v-if="tour?.shows?.length" class="show-filter">
      <label for="showSelect">Filter by show:</label>
      <select id="showSelect" v-model="selectedShowId" @change="onShowChange">
        <option value="">All shows</option>
        <option v-for="show in tour.shows" :key="show.id" :value="show.id">
          {{ formatShowOption(show) }}
        </option>
      </select>
    </base-stack>

    <base-stack as="dl" class="box">
      <base-stack direction="row" justify="space-between">
        <dt>Show tickets sold</dt>
        <dd>{{ tour?.ticketsSold || 0 }}</dd>
      </base-stack>
    </base-stack>

    <base-stack v-if="tour?.meetAndGreet" as="dl" class="box">
      <base-stack direction="row" justify="space-between">
        <dt>Secret Gathering tickets (+ bundle) sold</dt>
        <dd>{{ tour.meetAndGreet.ticketsSold }}</dd>
      </base-stack>
      <base-stack direction="row" justify="space-between">
        <dt>Secret Gathering bundles sold</dt>
        <dd>{{ tour.meetAndGreet.bundlesSold }}</dd>
      </base-stack>
    </base-stack>

    <meet-and-greet-purchases-table v-if="tour?.meetAndGreet" :tour="tour" />
  </base-stack>
</template>

<script lang="ts">
import { TourFragments } from '@/apollo/fragments/tour';
import { Tour } from '@/types/api';
import gql from 'graphql-tag';
import { Component, Prop, Vue } from 'vue-property-decorator';
import MeetAndGreetPurchasesTable from '../components/MeetAndGreetPurchasesTable.vue';

@Component({
  components: { MeetAndGreetPurchasesTable },
  apollo: {
    tour: {
      query: gql`
        query Tour($id: ID!, $showId: ID) {
          tour(id: $id) {
            ...TourStatistics
          }
        }
        ${TourFragments.TourStatistics}
      `,
      variables() {
        return {
          id: this.tourId,
          showId: this.selectedShowId || undefined,
        };
      },
      fetchPolicy: 'cache-and-network',
    },
  },
})
export default class TourStatistics extends Vue {
  @Prop({ required: true })
  public tourId!: string;

  tour?: Tour;
  selectedShowId: string = '';

  formatShowOption(show: any): string {
    const date = new Date(show.showDate).toLocaleDateString();
    const venue = show.address?.venue || 'Unknown venue';
    const city = show.address?.city || '';
    const description = show.description || '';
    return `${date} - ${venue}${city ? `, ${city}` : ''}${description ? ` (${description})` : ''}`;
  }

  onShowChange(): void {
    // Apollo will automatically refetch with new variables
    this.$apollo.queries.tour.refetch();
  }
}
</script>

<style lang="scss" scoped>
.box {
  border: 1px solid $color-theme-red;
  padding: 16px;
}

.show-filter {
  select {
    max-width: 400px;
  }
}
</style>
